/**
 * Allowed outcomes for a single logical row in file ingestion / generation pipelines.
 * Drives `RowProcessingResult.status`, generator row results, and payment-file row Zod DTOs.
 * Shaped for `z.nativeEnum` (same pattern as `PAYMENT_FILE_ROW_FAILURE_CODE`).
 */
export const ROW_PROCESSING_STATUS = {
    SUCCESS: 'success',
    SKIPPED: 'skipped',
    FAILED: 'failed',
};
//# sourceMappingURL=row-processing-status.js.map